import PaginationComponent from './index.vue'

const Pagination = {
  install: function(Vue) {
    Vue.component('Pagination', PaginationComponent)
  }
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js